
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homeloans/mortgage-rates/[[...slug]]",
      function () {
        return require("private-next-pages/homeloans/mortgage-rates/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homeloans/mortgage-rates/[[...slug]]"])
      });
    }
  